/**
 * Every path mounted inside the authenticated AppShell. Routes.tsx consumes
 * these, and lib/__tests__/notificationTarget.test.ts asserts the notification
 * allow-list against them — so a route cannot be added here without deciding
 * whether a notification may open it, and the allow-list cannot name a route
 * that does not exist. The shell's "*" catch-all is deliberately absent: it is
 * not a destination, it sends anything unmatched to the inbox.
 *
 * Import-free on purpose: Routes.tsx pulls in every page (and so axios), which
 * react-scripts' jest cannot collect.
 */
export const APP_SHELL_ROUTE_PATHS = {
  startFreeTrial: "/start-free-trial",
  dashboard: "/dashboard",
  chat: "/chat",
  charts: "/charts",
  compare: "/compare",
  projections: "/projections",
  portfolio: "/portfolio",
  portfolioManage: "/portfolio/manage",
  screener: "/screener",
  savedScreen: "/screener/s/:screenId",
  earnings: "/earnings",
  earningsCalendar: "/earnings/calendar",
  earningsCompany: "/earnings/company/:ticker",
  superInvestors: "/super-investors",
  superInvestor: "/super-investors/:cik",
  congressionalMember: "/super-investors/congressional/:memberName",
  trading212: "/portfolio/trading212",
  trading212Csv: "/portfolio/trading212/csv",
  trading212Api: "/portfolio/trading212/api",
  inbox: "/inbox",
  manageAlerts: "/inbox/alerts",
  notificationLink: "/n/:id",
  publications: "/publications",
  publication: "/publications/:slug",
} as const;
